<template>
  <div class="app" v-title data-title="富林印迹-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="2" />
    <div class="yj-banner rel">
      <img src="@/assets/images/wz-banner.png" class="db wp100" alt="banner">
      <div class="crumbs-nav df align_center justify_end fa_wh box-border">
        <router-link to="/" class="f16 fw">首页</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/wanzhuan/index" class="f16 fw">玩转富林</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/wanzhuan/gonglue" class="f16 fw">游记攻略</router-link>
      </div>
      <div class="yj-banner-tit df align_center flex_column justify_center ts fw">
        <div class="f50 ls1 b">玩转富林</div>
        <div class="f17 ls3">Explore Guangfulin</div>
      </div>
      <!-- <div class="yj-nav wp100">
        <div class="yj-nav-item df align_center justify_center" v-if="seriesList && seriesList.length > 0">
          <div class="yj-nav-box" v-for="item in seriesList" :key="item.Id" :class="seriesSelect == item.Code ? 'active': ''">
            <router-link :to="`/pages/wanzhuan/gonglue?series=${item.Code}`" class="yj-nav-link db f24">{{ item.Name }}</router-link>
          </div>
        </div>
      </div> -->
    </div>
    <div class="wz-gonglue mt30 pb100 w1400 auto df justify_between">
      <div class="w1000">
        <div class="wz-view-tit">
          <h1 class="f32 b" v-if="detailInfo">{{ detailInfo.Name }}</h1>
          <div class="df align_center mt15">
            <div class="mr40" v-if="detailInfo && detailInfo.PublishTime">发布时间：{{ detailInfo.PublishTime }}</div>
            <div v-if="detailInfo && detailInfo.Source">来源：{{ detailInfo.Source }}</div>
          </div>
        </div>
        <div class="wz-view-text tj f16 lh18 cell_bk mt30" v-if="detailInfo && detailInfo.Intro" v-html="detailInfo.Intro">
        </div>
      </div>
      <div class="wz-view-other">
        <div class="pd20 bgwh">
          <h3 class="f20 b">更多攻略</h3>
          <div class="wz-view-other-item" v-if="otherList && otherList.length > 0">
            <router-link :to="`/pages/wanzhuan/gonglue-view?id=${item.Id}&series=${item.Tag.Series}`" class="wz-view-other-box df pt15 pb15 w_line" style="cursor:pointer" 
            v-for="item in otherList" :key="item.Id">
              <div class="wz-view-other-text line_clamp3">{{ item.Intro | clearHtml(24) }}</div>
              <img v-if="item.Photo" :src="item.Photo + '!/both/120x72'" class="db ml15" alt="" />
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'
import strategyService from '@/services/client/cont/strategy'
import paramService from '@/services/client/option/params'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',
      paramCode: 'cont_tag_series',
      childCode: 230,
      seriesList: null,
      seriesSelect: null,
      detailId: null,
      detailInfo: null,
      filter: {
        Page: 1,
        PageSize: 5,
        Series: '游客游记',
      },
      otherList: null,
    }
  },
  components: { Header, Bottom,},
  watch: {
    '$route': {
      handler(to, from) {
        this.initPage();
      }
    }
  },
  mounted(){
    this.initPage();
    window.scrollTo(0,0);
  },
  methods:{
    initPage() {
      if(this.$route.query && this.$route.query.id) {
        this.detailId = this.$route.query.id;
      }
      if(this.$route.query && this.$route.query.series) {
        this.seriesSelect = this.$route.query.series;
        this.filter.Series = this.seriesSelect;
      }

      // this.loadParam();
      this.loadDetail();
    },
    loadParam() {
      this.seriesList = null;
      paramService.detail(this.paramCode, this.childCode).then(res => {
        if(res.Code == 200 && res.Data && res.Data.length > 0) {
          this.seriesList = res.Data;
          if(!this.seriesSelect) {
            this.filter.Series = res.Data[0].ValidValue;
            this.seriesSelect = res.Data[0].Code;
          }
        }
      })
    },
    loadDetail() {
      this.detailInfo = null;
      strategyService.detail(this.detailId).then(res => {
        if(res.Code == 200 && res.Data){
          this.detailInfo = res.Data;

          this.loadOtherData();
        }
      })
    },
    loadOtherData() {
      this.otherList = null;
      strategyService.list(this.filter).then(res => {
        if(res.Code == 200 && res.Data) {
          const data = res.Data;

          this.otherList = data.List;
        }
      })
    },
  },

}
</script>



// WEBPACK FOOTER //
// src/views/wanzhuan/gonglue-view.vue